<template>
    <div class="typing">
        <div class="flex items-center justify-center my-4">
            <XCheckbox
                @input="toggleTypingAnswerRequired(true)"
                :checked="answer.data.completely_correct"
                :disabled="!canEditQuiz"
                type="checkbox"
                size="md"
                theme="dark"
            >
                <span class="text-sm no-underline flex items-center mr-2 shadow-text-none">
                    {{ $t('question_completely_correct') }}
                </span>
            </XCheckbox>
            <XCheckbox
                @input="toggleTypingAnswerRequired(false)"
                :checked="!answer.data.completely_correct"
                :disabled="!canEditQuiz"
                type="checkbox"
                size="md"
                theme="dark"
            >
                <span class="text-sm no-underline flex items-center mr-2 shadow-text-none">
                    {{ $t('question_percentage') }}
                </span>
            </XCheckbox>
        </div>

        <template v-if="!answer.data.completely_correct">
            <div class="percent-match-box flex justify-center items-center mt-4">
                <label :for="`typing_accept_percent-${questionIndex}`" class="font-size-14 w-auto">
                    {{ $t('question_percentage_accept') }}
                </label>
                <XInput
                    v-validate="'required|min:0|max:100'"
                    @blur="onChangeTypeQuestionAccepted($event)"
                    :id="`typing_accept_percent-${questionIndex}`"
                    :name="`percent-${questionIndex}`"
                    :inline="true"
                    :value="answer.data.accepted_percentage"
                    :disabled="!canEditQuiz"
                    data-vv-as="accepted percentage"
                    class="input percentage-input"
                    type="number"
                    min="0"
                    max="100"
                />
                <span class="shadow-text-none">%</span>
            </div>
            <span
                v-if="errors.has(`percent-${questionIndex}`)"
                class="has-error text-red text-center mt-2 font-size-14 shadow-text-none"
            >
                {{ errors.first(`percent-${questionIndex}`) }}
            </span>
        </template>

        <div class="mt-4">
            <XInput
                v-validate="{ required: true }"
                @input="inputAnswer($event, 0)"
                :value="answer.title"
                :name="`answer-${questionIndex}`"
                :disabled="!canEditQuiz"
                :placeholder="$t('question_placeholder_correct_answer')"
                data-vv-as="typing answer"
                autocomplete="off"
                class="input input-block input-remove-margin input-text-alignment font-size-16 md:font-size-20"
                type="text"
                maxlength="50"
            />
        </div>
        <span
            v-if="errors.has(`answer-${questionIndex}`) && !answer.title"
            class="has-error text-red text-center mt-2 font-size-14 shadow-text-none"
        >
            * {{ errors.first(`answer-${questionIndex}`) }}
        </span>
    </div>
</template>

<script>
import quizCreator from '@/mixins/quiz-creator.js'
import XCheckbox from '@/components/v2/XCheckbox'
import XInput from '@/components/v2/XInput'

export default {
    components: {
        XCheckbox,
        XInput
    },

    mixins: [quizCreator],

    props: {
        questionIndex: {
            type: Number,
            required: true
        },

        answer: {
            type: Object,
            required: true
        }
    },

    methods: {
        toggleTypingAnswerRequired(value) {
            if (!this.canEditQuiz) return

            this.$store.commit('toggleTypingAnswerRequired', {
                questionIndex: this.questionIndex,
                answerIndex: 0,
                value
            })
        },

        onChangeTypeQuestionAccepted(event) {
            if (!this.canEditQuiz) return

            this.$store.commit('updateSortingMatchPercent', {
                questionIndex: this.questionIndex,
                value: event.target.value
            })
        }
    }
}
</script>

<style>
</style>